import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import Home from './pages/Home';
import OurClients from './pages/OurClients';
import TeamPage from './pages/TeamPage';
import EmployerJobs from './pages/EmployerJobs';
import AdminLogin from './pages/AdminLogin';
import EmployerLogin from './pages/EmployerLogin';
import JobSeekerLogin from './pages/JobSeekerLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import EmployerDashboard from './pages/employer/EmployerDashboard';
import JobSeekerDashboard from './pages/jobseeker/JobSeekerDashboard';
import JobDetails from './pages/JobDetails';
// Info Pages
import About from './pages/info/About';
import CareerGuidance from './pages/info/CareerGuidance';
import JobFairs from './pages/info/JobFairs';
import JobNotification from './pages/info/JobNotification';
import Entrepreneurship from './pages/info/Entrepreneurship';
import JobFacilitationCenter from './pages/info/JobFacilitationCenter';
import EducationSupport from './pages/info/EducationSupport';
import MedicalSupport from './pages/info/MedicalSupport';
import EnvironmentSupport from './pages/info/EnvironmentSupport';
import Contact from './pages/info/Contact';
import PrivacyPolicy from './pages/info/PrivacyPolicy';
import FAQ from './pages/info/FAQ';
import Donate from './pages/info/Donate';
import Achievements from './pages/info/Achievements';
import JobFairLanding from './pages/jobfairs/JobFairLanding';
import CandidateRegistration from './pages/jobfairs/CandidateRegistration';
import EmployerRegistration from './pages/jobfairs/EmployerRegistration';
import '@/App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-clients" element={<OurClients />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/employer-jobs" element={<EmployerJobs />} />
            <Route path="/job/:jobId" element={<JobDetails />} />
            <Route path="/adminvvsi/login" element={<AdminLogin />} />
            <Route path="/employer/login" element={<EmployerLogin />} />
            <Route path="/job-seeker/login" element={<JobSeekerLogin />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/employer/*" element={<EmployerDashboard />} />
            <Route path="/job-seeker/*" element={<JobSeekerDashboard />} />
            {/* Info Pages */}
            <Route path="/about" element={<About />} />
            <Route path="/career-guidance" element={<CareerGuidance />} />
            <Route path="/job-fairs" element={<JobFairs />} />
            <Route path="/job-notification" element={<JobNotification />} />
            <Route path="/entrepreneurship" element={<Entrepreneurship />} />
            <Route path="/job-facilitation-center" element={<JobFacilitationCenter />} />
            <Route path="/education-support" element={<EducationSupport />} />
            <Route path="/medical-support" element={<MedicalSupport />} />
            <Route path="/environment-disaster-support" element={<EnvironmentSupport />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/achievements" element={<Achievements />} />
            {/* Job Fair mini-sites (standalone header/footer) */}
            <Route path="/jobfairs/:slug" element={<JobFairLanding />} />
            <Route path="/jobfairs/:slug/register/candidate" element={<CandidateRegistration />} />
            <Route path="/jobfairs/:slug/register/employer" element={<EmployerRegistration />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
